import { themeQuartz } from 'ag-grid-community';
import { FONT_FAMILY, PRIMARY, SLATE } from 'helpers/theme';

// App-wide AG Grid theme (v34 Theming API) — one look for every grid, driven
// by the design tokens in helpers/theme.js. Per-site tweaks still work via
// inline `--ag-*` CSS variables on the wrapper, which override these params.
const agGridTheme = themeQuartz.withParams({
  fontFamily: FONT_FAMILY,
  fontSize: 13,
  accentColor: PRIMARY[600],
  borderColor: SLATE[200],
  headerBackgroundColor: SLATE[50],
  headerTextColor: SLATE[600],
  wrapperBorderRadius: 8
});

export default agGridTheme;
